import { Grid } from "@mui/material";
import { FC } from "react";
import { useGetListQuery } from "../../../../features/api/Api";
import { ITCForeignInput } from "../../../../interfaces/Contact";
import useLocales from "../../../../hooks/useLocales";
import {
  genderOptions,
  isExists,
  locale,
  params,
  socialStatusOptions,
} from "../../../../utils";
import {
  AutocompleteDropDown,
  DateInput,
  RadioInput,
  TextInput,
} from "../../../../components";

const TCForeignInput: FC<ITCForeignInput> = ({
  identityCardTypeId,
  socialStatusId,
  documentNo,
  genderId,
  validDate,
}) => {
  const { translate } = useLocales();

  const { data: identityCardTypes } = useGetListQuery<any>({
    resource: "fixity/customer/identityCardType",
    params: params,
  });

  let cardTypeName;
  if (!isExists(identityCardTypes?.data) || !isExists(identityCardTypeId)) {
    return null;
  }
  cardTypeName = identityCardTypes.data.find(
    (item: any) => item.id === identityCardTypeId
  )?.name;

  if (cardTypeName === "tc_foreign") {
    return (
      <>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={documentNo}
            label={translate(
              "resources.customers.related_persons.identity_document_no"
            )}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <DateInput
            name={validDate}
            label={translate(
              "resources.customers.related_persons.passport_valid_date"
            )}
            minDate={new Date()}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <AutocompleteDropDown
            name={socialStatusId}
            label={translate(
              "resources.customers.related_persons.socialStatuses"
            )}
            options={locale(
              socialStatusOptions,
              "resources.customers.related_persons."
            )}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <RadioInput
            name={genderId}
            label={translate("resources.customers.related_persons.gender")}
            radioGroup={locale(
              genderOptions,
              "resources.customers.related_persons."
            )}
          />
        </Grid>
      </>
    );
  }
  return null;
};

export default TCForeignInput;
